import useMedia from 'common/hooks/useMedia'
import { useCurrentCycleInfo } from 'modules/pond/api/selector'
import { useState, ReactNode, FC } from 'react'

import AddIcon from '@mui/icons-material/Add'
import { Box, Button } from '@mui/material'

interface DialogRenderProps {
  open: boolean
  onClose: () => void
}

interface RecordFeatureButtonProps {
  dialog: (props: DialogRenderProps) => ReactNode
  customComponent?: ReactNode
  hideButton?: boolean
  showButton?: boolean
  buttonText: string
  marginTop?: string
  onAfterOpen?: () => void
  onAfterClose?: () => void
}

export const RecordFeatureButton: FC<RecordFeatureButtonProps> = ({
  dialog,
  customComponent,
  hideButton = false,
  showButton = true,
  buttonText,
  marginTop = '-90px',
  onAfterOpen,
  onAfterClose,
}) => {
  const [open, setOpen] = useState(false)
  const isTablet = useMedia('lg')
  const cycleInfo = useCurrentCycleInfo()
  const isCompleted = cycleInfo?.status === 'completed'

  const handleOpen = () => {
    setOpen(true)
    if (onAfterOpen) {
      onAfterOpen()
    }
  }
  const handleClose = () => {
    setOpen(false)
    if (onAfterClose) {
      onAfterClose()
    }
  }

  if (hideButton || !showButton || isCompleted) return null

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: isTablet ? 'stretch' : 'flex-end',
        mb: 3,
        mt: isTablet ? { xs: 0, sm: -3 } : marginTop,
      }}
    >
      <Box sx={{ position: 'relative', width: isTablet ? '100%' : 'fit-content' }}>
        <Button
          color="primary"
          variant="contained"
          onClick={handleOpen}
          startIcon={<AddIcon sx={{ fontSize: 32 }} />}
          sx={{
            borderRadius: 1,
            fontSize: 16,
            fontWeight: 500,
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            width: isTablet ? '100%' : 'fit-content',
          }}
        >
          {buttonText}
        </Button>

        {customComponent}
      </Box>

      <Box className="record-food-dialog">{dialog({ open, onClose: handleClose })}</Box>
    </Box>
  )
}
